import { action, createRequestTypes } from "../../actions";

export const LOAD_DISTRICTS = createRequestTypes("LOAD_DISTRICTS");

export const loadDistricts = {
  request: () => action(LOAD_DISTRICTS.REQUEST, { }),
  success: response => action(LOAD_DISTRICTS.SUCCESS, { response }),
  failure: error => action(LOAD_DISTRICTS.FAILURE, { error }),
};
